module.exports = __webpack_public_path__ + "static/img/1067.9d9bdbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1067.jpg
// module id = 249
// module chunks = 0